import { PhoneOrderCreateInput } from '@/features/graphql/generated/graphql'
import { phoneOrderMutation } from '@/features/pos/components/OrderFinalization/mutations'
import { logger } from '@/features/pos/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { useMutation } from '@apollo/client'

export const useCreatePhoneOrder = (): ((
    cartKey: string,
    orderData: PhoneOrderCreateInput
) => Promise<string | undefined>) => {
    const handleError = useHandleErrorWithToast(logger)

    const [phoneOrder] = useMutation(phoneOrderMutation, { onError: handleError })

    return async (cartKey: string, orderData: PhoneOrderCreateInput) => {
        const { data } = await phoneOrder({ variables: { cartKey, orderData } })

        return data?.phoneOrder?.uuid
    }
}
